import { create } from 'zustand';
import dayjs from 'dayjs';

const initialAgendaState = {
  id: null,
  event_name: "",
  description: "",
  get begin_time() { return dayjs(); },
  end_time: null,
  private_task: false,
  user: null,
  owner: null,
  pet: null,
  product: null,
};

const useAgendaStore = create((set) => ({
  // Estado inicial
  agenda: { ...initialAgendaState },

  // Acciones
  setAgenda: (agenda) => set({ agenda }),

  // Acciones específicas
  updateAgenda: (updates) => set((state) => ({
    agenda: { ...state.agenda, ...updates }
  })),

  // Resetear agenda
  resetAgenda: () => set({ agenda: { ...initialAgendaState } })
}));

export default useAgendaStore; 